import React from 'react';

export default function DemographicTagEditor({
  tags,
  onChange,
  inputValue,
  onInputChange,
  label,
  placeholder,
  disabled
}) {
  const handleRemove = React.useCallback((tag) => {
    if (disabled) return;
    const next = (tags || []).filter((existing) => existing !== tag);
    onChange?.(next);
  }, [tags, onChange, disabled]);

  const handleAdd = React.useCallback((event) => {
    if (disabled) return;
    event.preventDefault();
    const raw = String(inputValue || '').trim();
    if (!raw) return;
    const next = Array.from(new Set([...(tags || []), raw]));
    onChange?.(next);
    onInputChange?.('');
  }, [inputValue, tags, onChange, onInputChange, disabled]);

  return (
    <div>
      <div style={{ color: '#9ca3af', marginBottom: 6 }}>{label || 'Demographics'}</div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 6 }}>
        {(tags || []).map((tag) => (
          <span
            key={tag}
            style={{
              background: '#1f2937',
              border: '1px solid #ff5a1f',
              color: '#e5e7eb',
              padding: '4px 8px',
              borderRadius: 999,
              fontSize: 12,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6
            }}
          >
            {tag}
            <button
              onClick={() => handleRemove(tag)}
              aria-label={`Remove ${tag}`}
              disabled={disabled}
              style={{ background: 'transparent', border: 0, color: '#93c5fd', cursor: disabled ? 'not-allowed' : 'pointer' }}
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <form onSubmit={handleAdd} style={{ display: 'flex', gap: 6 }}>
        <input
          aria-label="Add demographic tag"
          placeholder={placeholder || 'Add tag (e.g., Gen Z, US)'}
          value={inputValue}
          onChange={(event) => onInputChange?.(event.target.value)}
          disabled={disabled}
          style={{ flex: 1, padding: 8, borderRadius: 8, border: '1px solid #374151', background: '#0b0b0e', color: '#e5e7eb' }}
        />
        <button
          type="submit"
          disabled={disabled}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #374151', background: '#111827', color: '#e5e7eb', cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
          Add
        </button>
      </form>
    </div>
  );
}
